import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-aside',
    templateUrl: './aside.component.html',
    styleUrls: []
})
export class AsideComponent implements OnInit {

    constructor(protected router: ActivatedRoute) {
    }

    ngOnInit() {
    }
}
